import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { get } from '../helpers/request'

const useIsLogged = () => {
  const profile = useSelector(state => state.profile)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!profile) {
      get('/profile').then(response => {
        dispatch({ type: 'set-profile', profile: response})
      }).catch(error => {
        // TODO: do something?
      })
    }
  }, [profile, dispatch])

  return profile
}

export default useIsLogged